import './footer.css'

export default function Footer() {
  return (
    <div className='footer' id="footeri">
      <footer className='foot'>
      <i class="footerIcon fa-regular fa-envelope"></i>
        <p><a href="mailto:shailka8302@gmail.com" className='link' target = "_blank" rel="noreferrer">shailka8302@gmail.com</a></p>
      </footer>
    </div>
  )
}
